import { config } from './config/firebase';

export const makeApiPost =  function(route, data, callback) {

	var request = new XMLHttpRequest();
	request.open('POST', config.apiRoute + route);
	request.setRequestHeader('Content-Type', 'application/json');
	request.onreadystatechange = () => { 
		var res = request.responseText ? JSON.parse(request.responseText) : ""
		if (request.readyState === 4)
			callback(res, request.status) 
	}
	request.send(JSON.stringify(data))
}






// WEBPACK FOOTER //
// ./src/api.js